module.exports = __webpack_public_path__ + "static/media/modelY_BackgroundPic.34e9052c.jpg";